import React, { useEffect, useState } from 'react'
import { EmpListsVM } from '../../Structure/ViewModels/Admin/EmpListsVM'
import { Accordion, Col, Row } from 'react-bootstrap'
import DepartmentEmployees from './DepartmentEmployees'

const EmpLists = () => {
    const [vm , setVm] = useState<{viewModel:EmpListsVM}>({viewModel:new EmpListsVM()})
    const control = vm.viewModel
    useEffect(()=>{
        control.subscribeUpdate(setVm)
        control.getList()
    },[])



  return (
    <div className='d-flex flex-column py-3'>
        {
            control.Show(
                <Accordion defaultActiveKey={'1'} className='w-100 rounded-0' style={{outline:'none' , borderRadius:'0px'}}>
                {

                control.List.map((Department,index)=>(
                    <DepartmentEmployees key={index} Department={Department} roles={control.Roles} vm={control} />
                ))}
                </Accordion>
            )
        }

  </div>
  )
}

export default EmpLists
